import React, { useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

// Reusable password input with a consistent show/hide toggle. The native
// browser reveal control (Edge ::-ms-reveal / ::-ms-clear) is hidden so the
// eye button never appears/disappears inconsistently across browsers.
const PasswordField: React.FC<TextFieldProps> = ({
  InputProps,
  sx,
  ...rest
}) => {
  const [show, setShow] = useState(false);

  return (
    <TextField
      {...rest}
      type={show ? "text" : "password"}
      sx={[
        {
          "& input::-ms-reveal": { display: "none" },
          "& input::-ms-clear": { display: "none" },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShow((prev) => !prev)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              tabIndex={-1}
            >
              {show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordField;
